import Vue from 'vue';
import { printableUnitStatuses } from './enums';

Vue.filter('currencySign', (value, facilityData) => {
  // set currency as usd if not set or loaded.
  if (Number.isNaN(Number(value))) {
    return value;
  }
  const currency = facilityData && facilityData.pricing && facilityData.pricing.currency ? facilityData.pricing.currency : 'usd';
  return Number(value).toLocaleString('en', {
    style: 'currency',
    currency,
  });
});

Vue.filter('formatDate', (value) => {
  if (value) {
    const date = new Date(value);
    return date.toLocaleDateString('en-US');
  }

  return '-';
});

Vue.filter('printableStatus', (value) => {
  if (!value) {
    return '-';
  }

  if (printableUnitStatuses[value]) {
    return printableUnitStatuses[value];
  }

  return value;
});

Vue.filter('tierFilter', (value) => {
  if (value === 'AA') {
    return 'A+';
  }

  return value;
});



// WEBPACK FOOTER //
// ./src/utils/filters.js